import { log2 } from "./log2";
import moment from "moment";
import { getPersistenceData, setPersistenceData } from "./persistenceStorage";
import _ from "lodash";

const log = log2("ChatLS");
const WATCHING_CHAT_ID_KEY = "watching-chat-ids";
const MY_CHAT_IDS_KEY = "my-chat-ids";
const PENDING_MESSAGES = "pending-messages";
const PERMISSIONS_KEY = "permissions";

export function getConversations() {
    let conversations = JSON.parse(getPersistenceData("active-chats")) || [];
    for (let c of conversations) {
        c["isOnline"] = false;
    }
    return conversations;
}

let latestConversations = [];
let latestUpdateTS = Date.now();
let latestSyncTS = Date.now();

export function setConversations(conversations = []) {
    log.warn("setConversations deprecated");
    return;
    latestUpdateTS = Date.now();
    latestConversations = conversations;
}

export function getConversationsMeta() {
    try {
        return JSON.parse(getPersistenceData("conversation-metas"));
    } catch (e) {
        return null;
    }
}

export function setConversationsMeta(metas = {}) {
    log.info("local storage setConversationsMeta", { metas });
    setConversationsMeta.latestUpdateTS = Date.now();
    setConversationsMeta.lastData = metas;
}

export function getWatchingChatIds() {
    try {
        return JSON.parse(getPersistenceData(WATCHING_CHAT_ID_KEY)) || [];
    } catch (e) {
        setPersistenceData(WATCHING_CHAT_ID_KEY, JSON.stringify([]), true);
        return [];
    }
}

export function setWatchingChatIds(chatIds = []) {
    return setPersistenceData(WATCHING_CHAT_ID_KEY, JSON.stringify(chatIds), true);
}

export function setMyChatIds(chatIds = []) {
    return [];
    return setPersistenceData(MY_CHAT_IDS_KEY, JSON.stringify(chatIds), true);
}

export function getMyChatIds() {
    try {
        const ids = JSON.parse(getPersistenceData(MY_CHAT_IDS_KEY));
        return Array.isArray(ids) ? ids : [];
    } catch (e) {
        console.error("getMyChatIds error", e);
        return [];
    }
}

export function setLastPrivateChat(chat) {
    setPersistenceData("lastPrivateChat", JSON.stringify(chat), true);
}

export function getLastPrivateChat() {
    return Number(JSON.parse(getPersistenceData("lastPrivateChat"))) || 0;
}

export function pushLookedChatId(chatId) {
    let lookedChats = [];
    lookedChats = JSON.parse(getPersistenceData("lookedChats")) || [];
    if (!lookedChats.includes(chatId)) {
        lookedChats.push(chatId);
        setPersistenceData("lookedChats", JSON.stringify(lookedChats), true);
    }
}

export function deleteLookedChatFromStorage(chatId) {
    let lookedChats = [];
    lookedChats = JSON.parse(getPersistenceData("lookedChats")) || [];
    let newChats = [];
    for (let c of lookedChats) {
        if (c === chatId) {
            break;
        } else {
            newChats.push(c);
        }
    }
    setPersistenceData("lookedChats", JSON.stringify(newChats), true);
}

export function getLookedChatIds() {
    try {
        return JSON.parse(getPersistenceData("lookedChats")) || [];
    } catch (e) {
        setPersistenceData("lookedChats", JSON.stringify([]), true);
        return [];
    }
}

export const toNewMessagesModel = (messages, that, isChatBotV2, isPrivateChat = false, currentUserId) => {
    log("toNewMessagesModel", { messages: [...messages], isChatBotV2 });
    return messages.map((message) => {
        let type = "";
        let author = "";
        let metaExtend = "";
        let position = "middle";
        let senderName = "system";
        if (message.messageType === "system") {
            type = "system";
        } else if (message.messageType === "load-more") {
            type = "load-more";
        } else if (message.messageType === "whatsapp-user") {
            type = "text";
            author = "whatsapp-user";
            position = "right";
            metaExtend = "WhatsApp";
        } else if (message.messageType === "instagram-user") {
            type = "text";
            author = "instagram-user";
            position = "right";
            metaExtend = "instagram";
        } else if (message.messageType === "messenger-user") {
            type = "text";
            author = "messenger-user";
            position = "right";
            metaExtend = "messenger";
        } else if (["user", "private"].includes(message.messageType)) {
            type = "text";
            const isUserPopulated = typeof message.user === "object";
            const userId = (isUserPopulated ? message.user._id : message.user) || message.userId;

            const maybeUser = isUserPopulated ? message.user : that.getUser(userId);
            /*log("maybeUser", message.user, message.messageType, maybeUser);*/
            const userName = _.get(maybeUser, "name") || _.get(maybeUser, "username") || message.username || "";
            metaExtend = userName;
            author = userName;
            position = "right";
            if (isPrivateChat && userId !== currentUserId) {
                position = "left";
            }
            senderName = userName;
        } else if (message.messageType === "user-email") {
            type = "user-email";
            const maybeUser = that.getUser(message.userId);
            const userName = _.get(maybeUser, "name") || _.get(maybeUser, "username") || message.username || "";
            metaExtend = userName;
            author = userName;
            position = "right";
            if (isPrivateChat && message.userId !== currentUserId) {
                position = "left";
            }
            senderName = userName;
        } else if (message.messageType === "user-sms") {
            type = "user-sms";
            const maybeUser = that.getUser(message.userId);
            const userName = _.get(maybeUser, "name") || _.get(maybeUser, "username") || message.username || "";
            metaExtend = userName;
            author = userName;
            position = "right";
            if (isPrivateChat && message.userId !== currentUserId) {
                position = "left";
            }
            senderName = userName;
        } else if (["user-media"].includes(message.messageType)) {
            log("user-media message", message);
            const isUserPopulated = typeof message.user === "object";
            const userId = (isUserPopulated ? message.user._id : message.user) || message.userId;
            const mime = _.get(message, "asset.ext", "") || "";
            const audioMimes = ["mp3", "ogg", "wav", "flac", "oga"];
            type = !!audioMimes.find((x) => mime.includes(x))
                ? "audio"
                : ["jpg", "jpeg", "png"].includes(mime)
                ? "image"
                : "asset";
            const maybeUser = that.getUser(message.user);
            const userName = maybeUser && maybeUser.name ? maybeUser.name : message.username || "";
            metaExtend = userName;
            author = userName;
            position = "right";
            if (isPrivateChat && userId !== currentUserId) {
                position = "left";
            }
            senderName = userName;
        } else if (["whatsapp-user-media"].includes(message.messageType)) {
            log("whatsapp-user-media message", message);
            const mime = _.get(message, "asset.ext", "") || "";
            const audioMimes = ["mp3", "ogg", "wav", "flac", "oga"];
            type = !!audioMimes.find((x) => mime.includes(x))
                ? "audio"
                : ["jpg", "jpeg", "png"].includes(mime)
                ? "image"
                : "asset";
            const userName = "Whatsapp";
            metaExtend = userName;
            author = userName;
            position = "right";
            senderName = userName;
        } else if (["visitor-media"].includes(message.messageType)) {
            const mime = _.get(message, "asset.ext", "") || "";
            type = mime.includes("mp3") ? "audio" : ["jpg", "jpeg", "png"].includes(mime) ? "image" : "asset";
            author = "Visitor";
            senderName = "visitor";
            position = "left";
        } else if (message.messageType.includes("chatbot")) {
            type = message.messageType === "chatbot" ? "text" : message.messageType;
            const userName = "ChatBot";
            metaExtend = userName;
            author = userName;
            position = isChatBotV2 ? "left" : "right";
            senderName = userName;
        } else if (message.messageType === "whatsapp-business-api-template") {
            type = message.messageType;
            const userName = "Broadcast";
            metaExtend = userName;
            author = userName;
            position = isChatBotV2 ? "left" : "right";
            senderName = userName;
        } else if (message.messageType === "meta-post") {
            type = message.messageType;
            const userName = "Instagram/Facebook Post";
            metaExtend = userName;
            author = userName;
            position = isChatBotV2 ? "left" : "right";
            senderName = userName;
        } else if (message.messageType === "user_channel_message") {
            type = "text";
            const maybeUser = that.getUser(message.userId);
            const isMe = maybeUser ? maybeUser._id === that.user._id : false;
            const userName = maybeUser && maybeUser.name ? maybeUser.name : message.username || "";
            metaExtend = userName;
            author = isMe ? "me" : userName;
            position = isMe ? "right" : "left";
            senderName = userName;
        } else if (message.messageType === "visitor") {
            type = "text";
            author = isChatBotV2 ? "You" : "me";
            senderName = "visitor";
            position = isChatBotV2 ? "right" : "left";
        } else if (message.messageType === "divider") {
            type = "divider";
            author = "";
            senderName = "";
            position = "middle";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "conversation-separator") {
            type = "conversation-separator";
            author = "";
            senderName = "";
            position = "middle";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "day-separator") {
            type = "day-separator";
            author = "";
            senderName = "";
            position = "middle";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "visitor-location") {
            type = "location";
            author = "";
            senderName = "";
            position = "left";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "user-location") {
            type = "location";
            author = "";
            senderName = "";
            position = "right";
            const isUserPopulated = typeof message.user === "object";
            const userId = (isUserPopulated ? message.user._id : message.user) || message.userId;
            if (isPrivateChat && userId !== currentUserId) {
                position = "left";
            }
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "whatsapp-user-location") {
            type = "location";
            author = "Whatsapp User";
            senderName = "";
            position = "right";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        } else if (message.messageType === "select-reservation-day") {
            type = "select-reservation-day";
            author = "";
            senderName = "";
            position = "left";
            metaExtend = moment(message.createdDate).format("DD-MM-YYYY");
        }
        let metaSuffix = message.messageType === "private" ? that.$t("message.privateMessage") : "";
        let meta = metaExtend.length
            ? metaExtend + " - " + moment(message.createdDate).format("HH:mm")
            : moment(message.createdDate).format("HH:mm");
        let returnObject = {
            type,
            author,
            senderName,
            position,
            data: {
                text: message.message || message.description,
                meta,
                meta2: metaSuffix.length ? metaSuffix : undefined,
                asset: message["asset"] && message.asset,
            },
            raw: message,
        };
        if (message.messageType === "user_channel_message") {
            const id = message.createdDate;
            returnObject = { ...returnObject, id };
        }
        // log("toNewMessagesModel single", { message: _.cloneDeep(message), after: returnObject });
        return returnObject;
    });
};

export function getPendingMessages() {
    try {
        return JSON.parse(getPersistenceData(PENDING_MESSAGES)) || [];
    } catch (e) {
        setPersistenceData(PENDING_MESSAGES, JSON.stringify([]), true);
        return [];
    }
}

export function setPendingMessages(messages) {
    return setPersistenceData(PENDING_MESSAGES, JSON.stringify(messages), true);
}

export function getPermissionsFormLocalStorage() {
    try {
        const res = JSON.parse(getPersistenceData(PERMISSIONS_KEY));
        return Array.isArray(res) ? res : [];
    } catch (e) {
        setPersistenceData(PERMISSIONS_KEY, JSON.stringify([]), true);
        return [];
    }
}

setInterval(() => {
    if (latestSyncTS !== latestUpdateTS) {
        latestSyncTS = Date.now();
        setPersistenceData("active-chats", JSON.stringify(latestConversations), true);
        log.debug("LocalStorage:active-chats SYNC NOW");
    }
    if (setConversationsMeta.latestSyncTS !== setConversationsMeta.latestUpdateTS && setConversationsMeta.lastData) {
        log.debug("setInterval setConversationsMeta", {
            metas: setConversationsMeta.lastData,
        });
        setConversationsMeta.latestSyncTS = Date.now();
        setPersistenceData("conversation-metas", JSON.stringify(setConversationsMeta.lastData), true);
    }
}, 60 * 1000);

window.addEventListener("beforeunload", (e) => {
    setPersistenceData("active-chats", JSON.stringify(latestConversations), true);
    if (setConversationsMeta.lastData)
        setPersistenceData("conversation-metas", JSON.stringify(setConversationsMeta.lastData), true);
    // Older browsers supported custom message
    //do not show alert
    e.preventDefault();
    e.returnValue = "";
    return false;
});
